import type { Bilingual } from ".";

// Post-purchase thank-you / receipt / account-claim page. Language follows the
// order's resolved checkout language (page override, else seller default), not
// the dashboard toggle. Resolved via translate() with status.checkout_language.
export const thankyou: Bilingual = {
  ms: {
    "ty.orderNotFound": "Pesanan tidak dijumpai",
    "ty.loadError": "Tidak dapat memuatkan pesanan anda",
    "ty.verifying": "Mengesahkan pembayaran…",
    "ty.verifyingTimeout": "Ia mengambil masa lebih lama daripada biasa. Jika anda sudah membayar, akses akan muncul sebaik sahaja disahkan.",
    "ty.verifyingWait": "Sila tunggu sebentar, jangan tutup halaman ini.",
    "ty.recheck": "Semak semula",
    "ty.retryError": "Tidak dapat memulakan semula pembayaran",
    "ty.paymentIncomplete": "Pembayaran tidak selesai",
    "ty.paymentFailedDesc": "Pembayaran anda dibatalkan atau gagal. Anda boleh cuba lagi untuk meneruskan pembayaran.",
    "ty.tryAgain": "Cuba lagi",
    "ty.resumeTitle": "Selesaikan pembayaran anda",
    "ty.resumeDesc":
      "Pesanan anda masih tersimpan, cuma bayaran belum diterima. Tekan butang di bawah untuk bayar — anda boleh pilih kaedah pembayaran lain jika yang sebelum ini bermasalah.",
    "ty.payNow": "Bayar sekarang",
    "ty.paymentSuccess": "Pembayaran berjaya 🎉",
    "ty.thanksLine": "Terima kasih, {name}. Pesanan {amount} disahkan.",
    "ty.yourProducts": "Produk anda",
    "ty.accessPrepareFailed": "Akses anda belum dapat disediakan. Sila cuba lagi sebentar.",
    "ty.accessReady": "Akses anda sudah sedia.",
    "ty.cod.received": "Pesanan diterima 🎉",
    "ty.cod.payOnDelivery": "Bayar {amount} secara tunai kepada kurier semasa barang sampai.",
    "ty.cod.orderSummary": "Ringkasan pesanan",
    "ty.cod.repeated": "Pesanan ini sudah kami terima tadi — tak perlu buat pesanan semula.",
    "ty.cod.emailed": "Pengesahan pesanan dihantar ke {email} — semak inbox (atau folder spam).",
    "ty.ikl.couponTitle": "Kupon untuk anda",
    "ty.ikl.youSaved": "Anda jimat {amount} dengan kupon iklan",
    "ty.ikl.couponSub": "{n} kupon kedai",
    "ty.ikl.endsIn": "tamat dalam",
    "ty.ikl.off": "potongan",
    "ty.ikl.discount": "diskaun",
    "ty.ikl.minSpend": "Min. belanja {amount}",
    "ty.ikl.noMin": "Tiada minimum",
    "ty.ikl.claimedShort": "Dituntut",
    "ty.ikl.claimAll": "Tuntut semua kupon",
    "ty.ikl.allClaimed": "Semua kupon dituntut · terus dipakai di checkout",
    "ty.ikl.fine": "Ditanggung penjual. Hanya untuk anda, tak boleh dikongsi.",
    "ty.ikl.claimed": "Kupon dituntut. Terus dipakai di checkout.",
    "ty.ikl.claimFailed": "Kupon tidak dapat dituntut. Cuba lagi.",
    "ty.ikl.forYou": "Mungkin anda suka",
    "ty.ikl.sponsored": "Ditaja",
    "ty.ikl.bumpTitle": "Kupon {label} anda untuk {name}",
    "ty.ikl.bumpSub": "Kod {code} · dari {store} · sah 72 jam",
    "ty.ikl.bumpUse": "Guna kupon",
    "ty.ikl.ad": "Ditaja",
    "ty.ikl.tagFixed": "Kupon {amount}",
    "ty.ikl.tagPct": "Diskaun {pct}%",
    "ty.ikl.close": "Tutup",
    "ty.track.title": "Status penghantaran",
    "ty.track.tracking": "No. penjejakan",
    "ty.track.shippedAt": "Dihantar pada",
    "ty.track.deliveredAt": "Sampai pada",
    "ty.track.deliverTo": "Hantar ke",
    "ty.track.cancelled": "Pesanan ini telah dibatalkan.",
    "ty.track.step.unfulfilled": "Belum proses",
    "ty.track.step.processing": "Diproses",
    "ty.track.step.shipped": "Dihantar",
    "ty.track.step.delivered": "Selesai",
    "ty.receipt": "Resit",
    "ty.printSave": "Cetak / Simpan PDF",
    "ty.purchaseReceipt": "Resit pembelian",
    "ty.receiptUpper": "RESIT",
    "ty.for": "Untuk",
    "ty.date": "Tarikh",
    "ty.status": "Status",
    "ty.paid": "Dibayar",
    "ty.price": "Harga",
    "ty.total": "Jumlah",
    "ty.paymentMethodLine": "Kaedah pembayaran: {method}",
    "ty.refLine": " · Rujukan: {ref}",
    "ty.thanksPurchase": "Terima kasih atas pembelian anda.",
    "ty.pm.toyyibpay": "ToyyibPay (FPX)",
    "ty.pm.stripe": "Kad (Stripe)",
    "ty.pm.bayarcash": "BayarCash (FPX)",
    "ty.pm.chip": "CHIP (kad, FPX & e-dompet)",
    "ty.pm.atome": "Atome (bayar 3x)",
    "ty.pm.billplz": "Billplz (FPX)",
    "ty.pm.none": "—",
    "ty.accountExists": "Akaun anda sudah wujud",
    "ty.accountExistsDesc": "Emel {email} sudah mempunyai akaun. Log masuk dengan kata laluan sedia ada anda untuk akses produk anda.",
    "ty.login": "Log masuk",
    "ty.email": "Emel",
    "ty.password": "Kata laluan",
    "ty.signingIn": "Melog masuk anda…",
    "ty.signedInTitle": "Anda telah log masuk ✓",
    "ty.signedInDesc": "Akses produk anda di bawah.",
    "ty.credLoginLink": "Pautan log masuk",
    "ty.credSentTitle": "Butiran log masuk dihantar ke emel anda",
    "ty.credSentDesc": "Kami hantar pautan log masuk, emel dan kata laluan ke {email}. Anda tak perlu hafal apa-apa sekarang — semuanya ada dalam emel itu.",
    "ty.credSentHint": "Kata laluan penuh hanya ada dalam emel tersebut (semak folder spam jika tiada). Anda akan diminta tukar kepada kata laluan sendiri semasa masuk dashboard.",
    "ty.goDashboard": "Pergi ke dashboard saya",
  },
  en: {
    "ty.orderNotFound": "Order not found",
    "ty.loadError": "Could not load your order",
    "ty.verifying": "Verifying payment…",
    "ty.verifyingTimeout": "This is taking longer than usual. If you’ve already paid, access will appear once it’s confirmed.",
    "ty.verifyingWait": "Please wait a moment — don’t close this page.",
    "ty.recheck": "Check again",
    "ty.retryError": "Could not restart payment",
    "ty.paymentIncomplete": "Payment not completed",
    "ty.paymentFailedDesc": "Your payment was cancelled or failed. You can try again to continue.",
    "ty.tryAgain": "Try again",
    "ty.resumeTitle": "Complete your payment",
    "ty.resumeDesc":
      "Your order is still saved — we just haven't received payment yet. Tap below to pay, and feel free to pick a different payment method if the last one gave you trouble.",
    "ty.payNow": "Pay now",
    "ty.paymentSuccess": "Payment successful 🎉",
    "ty.thanksLine": "Thank you, {name}. Your {amount} order is confirmed.",
    "ty.yourProducts": "Your products",
    "ty.accessPrepareFailed": "We couldn't prepare your access yet. Please try again in a moment.",
    "ty.accessReady": "Your access is ready.",
    "ty.cod.received": "Order received 🎉",
    "ty.cod.payOnDelivery": "Pay {amount} in cash to the courier when your order arrives.",
    "ty.cod.orderSummary": "Order summary",
    "ty.cod.repeated": "We already received this order a moment ago — no need to order again.",
    "ty.cod.emailed": "Your order confirmation is on its way to {email} — check your inbox (or spam folder).",
    "ty.ikl.couponTitle": "Coupons for you",
    "ty.ikl.youSaved": "You saved {amount} with the ad coupon",
    "ty.ikl.couponSub": "{n} shop coupons",
    "ty.ikl.endsIn": "ends in",
    "ty.ikl.off": "off",
    "ty.ikl.discount": "off",
    "ty.ikl.minSpend": "Min. spend {amount}",
    "ty.ikl.noMin": "No minimum",
    "ty.ikl.claimedShort": "Claimed",
    "ty.ikl.claimAll": "Claim all coupons",
    "ty.ikl.allClaimed": "All coupons claimed · applied at checkout",
    "ty.ikl.fine": "Paid for by the seller. Yours only, not shareable.",
    "ty.ikl.claimed": "Coupons claimed. They apply at checkout.",
    "ty.ikl.claimFailed": "Could not claim the coupon. Try again.",
    "ty.ikl.forYou": "You may also like",
    "ty.ikl.sponsored": "Sponsored",
    "ty.ikl.bumpTitle": "Your {label} coupon for {name}",
    "ty.ikl.bumpSub": "Code {code} · from {store} · valid 72 hours",
    "ty.ikl.bumpUse": "Use coupon",
    "ty.ikl.ad": "Ad",
    "ty.ikl.tagFixed": "{amount} coupon",
    "ty.ikl.tagPct": "{pct}% off",
    "ty.ikl.close": "Close",
    "ty.track.title": "Delivery status",
    "ty.track.tracking": "Tracking number",
    "ty.track.shippedAt": "Shipped at",
    "ty.track.deliveredAt": "Delivered at",
    "ty.track.deliverTo": "Deliver to",
    "ty.track.cancelled": "This order has been cancelled.",
    "ty.track.step.unfulfilled": "Unfulfilled",
    "ty.track.step.processing": "Processing",
    "ty.track.step.shipped": "Shipped",
    "ty.track.step.delivered": "Delivered",
    "ty.receipt": "Receipt",
    "ty.printSave": "Print / Save PDF",
    "ty.purchaseReceipt": "Purchase receipt",
    "ty.receiptUpper": "RECEIPT",
    "ty.for": "To",
    "ty.date": "Date",
    "ty.status": "Status",
    "ty.paid": "Paid",
    "ty.price": "Price",
    "ty.total": "Total",
    "ty.paymentMethodLine": "Payment method: {method}",
    "ty.refLine": " · Reference: {ref}",
    "ty.thanksPurchase": "Thank you for your purchase.",
    "ty.pm.toyyibpay": "ToyyibPay (FPX)",
    "ty.pm.stripe": "Card (Stripe)",
    "ty.pm.bayarcash": "BayarCash (FPX)",
    "ty.pm.chip": "CHIP (card, FPX & e-wallet)",
    "ty.pm.atome": "Atome (pay in 3)",
    "ty.pm.billplz": "Billplz (FPX)",
    "ty.pm.none": "—",
    "ty.accountExists": "Your account already exists",
    "ty.accountExistsDesc": "The email {email} already has an account. Log in with your existing password to access your products.",
    "ty.login": "Log in",
    "ty.email": "Email",
    "ty.password": "Password",
    "ty.signingIn": "Signing you in…",
    "ty.signedInTitle": "You're signed in ✓",
    "ty.signedInDesc": "Access your products below.",
    "ty.credLoginLink": "Login link",
    "ty.credSentTitle": "Your login details are in your email",
    "ty.credSentDesc": "We've sent the login link, your email and your password to {email}. Nothing to memorise right now — it's all in that email.",
    "ty.credSentHint": "The full password is only in that email (check your spam folder if it hasn't arrived). You'll be asked to change it to your own password on the way into your dashboard.",
    "ty.goDashboard": "Go to my dashboard",
  },
};
